import globals from '../../cfg/globals.json';
import { Link } from '@mui/material';
import { Typography } from '@mui/material';

export default function Copyright(props) {
    return (
        <Typography variant="body2" color="text.secondary" align="center"  {...props}>
            {'Copyright © '}
            <Link color="inherit" href={globals.GLOBAL_app_link}>
                {globals.GLOBAL_app_name}
            </Link>{' '}
            {new Date().getFullYear()}
            {'.'}
        </Typography>
    );
}